module.exports = __webpack_public_path__ + "media/images/brands-81692c5f5d52ae21b5f45a88cf517c43.png";